var map = {
	"./2020-05-18-a-markdown-blog.json": 2448,
	"./2020-05-18-oil-price-dropped-drastically.json": 1800,
	"./2020-05-18-this-is-my-first-netlifycms-blog.json": 754,
	"./2020-05-18-this-is-my-second-netlifycms.json": 6484,
	"./2020-05-18-user-journey-map.json": 2768,
	"./2020-05-23-another-markdown-blogiii.json": 776,
	"./2020-05-26-a-new-markdownblog.json": 3024,
	"./2020-06-08-a-markdown-image-that-was-not-displayed-due-to-config-yml.json": 5520,
	"./2020-06-08-another-markdown-picture-that-was-not-displayed.json": 9476,
	"./2020-06-08-my-final-markdown-img-activity.json": 3720,
	"./2020-06-08-only-an-uploaded-pictrue.json": 224,
	"./2020-06-10-automating-typing-tasks-with-optical-character-recognition-in-python.json": 6728,
	"./2020-07-13-a-category-blog.json": 1596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1308;